const OPERATION = Object.freeze({
    SEARCH_SELECTED: 'search.selected',
    SEARCH_FILTER: 'search.filter',
    SEARCH_ALL: 'search.all',
    SEARCH_SELECT_HOTEL: 'search.select_hotel',
    SEARCH_PLACE: 'search.place',
    HOTEL_DETAILS: 'hotel.details',
    HOTEL_DEALS: 'hotel.deals',
    HOTEL_RECHECK: 'hotel.recheck',
    HOTEL_RECHECK_LAZY: 'hotel.recheck_lazy',
    RESERVATION_CREATE: 'reservation.create',
    RESERVATION_CANCEL: 'reservation.cancel',
    RESERVATION_VOUCHER: 'reservation.voucher',
    PAYMENT_STATUS: 'payment.status',
    STORAGE_SESSION: 'storage.session',
    RENDER_APP: 'render.app',
    API_OTHER: 'api.other',
});

const CATEGORY = Object.freeze({
    HTTP: 'http',
    NETWORK: 'network',
    TIMEOUT: 'timeout',
    INVALID_RESPONSE: 'invalid_response',
    INVALID_STATE: 'invalid_state',
    STORAGE: 'storage',
    RENDER: 'render',
    UNEXPECTED: 'unexpected',
});

const CODE = Object.freeze({
    HOTEL_DEALS_CACHE_MISSING: 'HOTEL_DEALS_CACHE_MISSING',
    HOTEL_DEALS_EXPIRED: 'HOTEL_DEALS_EXPIRED',
    HOTEL_DEALS_EMPTY: 'HOTEL_DEALS_EMPTY',
    UNKNOWN_API_ERROR: 'UNKNOWN_API_ERROR',
    NETWORK_ERROR: 'NETWORK_ERROR',
    REQUEST_TIMEOUT: 'REQUEST_TIMEOUT',
    INVALID_RESPONSE: 'INVALID_RESPONSE',
    INVALID_STATE: 'INVALID_STATE',
    STORAGE_ERROR: 'STORAGE_ERROR',
    RENDER_ERROR: 'RENDER_ERROR',
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
});

const OUTCOME = Object.freeze({
    FAILED: 'failed',
    RECOVERED: 'recovered',
    CANCELLED: 'cancelled',
    STALE: 'stale',
    UNKNOWN: 'unknown',
});

const IMPACT = Object.freeze({
    BLOCKED: 'blocked',
    DEGRADED: 'degraded',
    NONE: 'none',
    UNKNOWN: 'unknown',
});

const STORAGE_STORE = Object.freeze({
    SESSIONS: 'SESSIONS',
    TRAVEL_POLICIES: 'TRAVEL_POLICIES',
    HOTELS: 'HOTELS',
    SHALLOWS: 'SHALLOWS',
    DEALS: 'DEALS',
    BANNED_DEALS: 'BANNED_DEALS',
    RESERVATION_ATTEMPTS: 'RESERVATION_ATTEMPTS',
    FILTERS: 'FILTERS',
    FINISHED: 'FINISHED',
    SETTINGS: 'SETTINGS',
    ROOM_SUPPLIERS: 'ROOM_SUPPLIERS',
    MAPPING: 'MAPPING',
    PLACES: 'PLACES',
});

const OPERATIONS = new Set(Object.values(OPERATION));
const CATEGORIES = new Set(Object.values(CATEGORY));
const CODES = new Set(Object.values(CODE));
const OUTCOMES = new Set(Object.values(OUTCOME));
const IMPACTS = new Set(Object.values(IMPACT));
const STORAGE_STORES = new Set(Object.values(STORAGE_STORE));

const EXPECTED_REJECTION_STATUSES = new Set([400, 409, 410, 422]);

function isExpectedRejectionStatus(status) {
    return EXPECTED_REJECTION_STATUSES.has(status);
}

function requireMember(value, members, field) {
    if (!members.has(value)) {
        throw new TypeError(`Invalid observability ${field}`);
    }
    return value;
}

function optionalRequestId(value) {
    return typeof value === 'string' && /^[A-Za-z0-9_-]{8,64}$/.test(value) ? value : undefined;
}

function validHttpStatus(value) {
    return Number.isInteger(value) && value >= 100 && value <= 599 ? value : undefined;
}

module.exports = {
    OPERATION, CATEGORY, CODE, OUTCOME, IMPACT, STORAGE_STORE,
    OPERATIONS, CATEGORIES, CODES, OUTCOMES, IMPACTS, STORAGE_STORES,
    requireMember, optionalRequestId, validHttpStatus, isExpectedRejectionStatus,
};
